import { SafetyOutlined } from '@ant-design/icons';

const adminMenu = [
  {
    name: 'Divider',
    id: 'administration-divider',
    divider: true,
  },
  {
    name: 'Administration',
    id: 'administration',
    icon: SafetyOutlined,
    route: '/admin',
  },
  {
    name: 'Reporting',
    id: 'administration-reporting',
    mpid: 'administration',
    route: '/admin/reporting',
    abilityMode: 'any',
    abilities: [
      { subject: 'Query', field: 'partners' },
      { subject: 'Query', field: 'chats' },
      { subject: 'Query', field: 'experts' },
      { subject: 'Query', field: 'revenueReport' },
    ],
  },
  {
    name: 'Dashboard',
    id: 'administration-dashboard',
    mpid: 'administration-reporting',
    abilityMode: 'any',
    abilities: [{ subject: 'Query', field: 'revenueReport' }],
    route: '/admin/reporting/dashboard',
  },
  {
    name: 'Health',
    id: 'administration-reporting-health',
    mpid: 'administration-reporting',
    abilities: [{ subject: 'Query', field: 'health' }],
    route: '/admin/reporting/health',
  },
  {
    name: 'Monitoring',
    id: 'administration-chat-monitoring',
    mpid: 'administration-reporting',
    abilities: [{ subject: 'Query', field: 'chats' }],
    route: '/admin/reporting/monitoring',
  },
  {
    name: 'Revenue',
    id: 'administration-revenue-report',
    mpid: 'administration-reporting',
    abilities: [{ subject: 'Query', field: 'revenueReport' }],
    route: '/admin/reporting/revenue',
  },
  {
    name: 'Billing',
    id: 'administration-billing',
    mpid: 'administration-reporting',
    abilities: [{ subject: 'Query', field: 'payouts' }],
    route: '/admin/billing',
  },
  {
    name: 'IP Report',
    id: 'administration-ip-report',
    mpid: 'administration-reporting',
    abilities: [{ action: 'update', subject: 'Ip', field: 'blockedAt' }],
    route: '/admin/ip-report',
  },
  {
    name: 'Partners',
    id: 'administration-partners',
    mpid: 'administration',
    abilities: [{ subject: 'Query', field: 'partners' }],
    route: '/admin/partners',
  },
  {
    name: 'Add Partner',
    id: 'administration-partners-register',
    mpid: '-1',
    abilities: [{ action: 'create', subject: 'Partner' }],
    route: '/admin/partners/register',
  },
  {
    name: 'Interactions',
    id: 'administration-interactions',
    mpid: 'administration',
    abilities: [{ subject: 'Query', field: 'chats' }],
    route: '/admin/interactions',
  },
  {
    name: 'Experts',
    id: 'administration-guurus',
    mpid: 'administration',
    abilities: [{ subject: 'Query', field: 'experts' }],
    route: '/admin/guurus',
  },
  {
    name: 'Automation',
    id: 'administration-automation',
    mpid: 'administration',
    route: '/admin/automation',
  },
  {
    name: 'Predictions',
    id: 'administration-automation-questions',
    mpid: 'administration-automation',
    abilities: [{ subject: 'Query', field: 'questions' }],
    route: '/admin/automation/predictions',
  },
  {
    name: 'Predict',
    id: 'administration-automation-predict',
    mpid: '-1',
    abilities: [{ subject: 'Query', field: 'validateQuestion' }],
    route: '/admin/automation/predict',
  },
  {
    name: 'Intents',
    id: 'administration-automation-intents',
    mpid: 'administration-automation',
    abilities: [{ action: 'manage', subject: 'Intent' }],
    route: '/admin/automation/intents',
  },
  {
    name: 'Topics',
    id: 'administration-automation-topics',
    mpid: 'administration-automation',
    abilities: [{ action: 'create', subject: 'Topic' }],
    route: '/admin/automation/topics',
  },
  {
    name: 'Translations',
    id: 'administration-translations',
    mpid: 'administration',
    abilities: [{ action: 'update', subject: 'Translation' }],
    route: '/admin/translations',
  },
  {
    name: 'Categories',
    id: 'administration-categories',
    mpid: 'administration',
    abilities: [{ action: 'update', subject: 'Category' }],
    route: '/admin/categories',
  },
  {
    name: 'Publications',
    id: 'administration-publications',
    mpid: 'administration',
    abilityMode: 'any',
    abilities: [{ action: 'update', subject: 'GlobalNews' }],
    route: '/admin/publications',
  },
  {
    name: 'Permissions',
    id: 'administration-permissions',
    mpid: 'administration',
    abilityMode: 'any',
    abilities: [{ action: 'create', subject: 'GlobalRoles' }],
    route: '/admin/permissions',
  },
];

export default adminMenu;
